import { useParams, useSearchParams } from 'react-router-dom';

import { PCFooter } from '@commonPackage/components';
import { contactList, ContactType } from '@commonPackage/constants';
import { ReactComponent as ActivitySvg } from '@portalCommon/assets/svg/icon-activity.svg';
import { ReactComponent as AgentSvg } from '@portalCommon/assets/svg/icon-agent.svg';
import { ReactComponent as CooperationSvg } from '@portalCommon/assets/svg/icon-cooperation.svg';
import { MetaConfig } from '@portalCommon/components';
import { HIDE_TAB_LIST, RouterConfigEnum } from '@portalCommon/constants';
import { useEnhancedNavigation } from '@portalCommon/hooks';

import classnames from 'classnames/bind';
import { Back2Top, Contact as ContactComponent, NavHeader } from '@/components';

import Activity from './components/Activity';
import Agent from './components/Agent';
import Cooperation from './components/Cooperation';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const Contact = ({ isCommon = false }: { isCommon?: boolean }) => {
  const { contactType } = useParams();
  const [searchParams] = useSearchParams();
  const fromPage = searchParams.get('from_page') || '';

  const enhancedNavigate = useEnhancedNavigation();
  const renderMap = new Map([
    [
      ContactType.activity,
      {
        content: <Activity className={cx('activity-content')} key={ContactType.activity}></Activity>,
        svg: (active?: boolean) => (
          <ActivitySvg className={cx('svg1')} fill={active ? 'rgba(255,255,255,0.08)' : 'rgba(117,102,245,0.08)'} />
        ),
      },
    ],
    [
      ContactType.agent,
      {
        content: <Agent className={cx('agent-content')} key={ContactType.agent}></Agent>,
        svg: (active?: boolean) => (
          <AgentSvg className={cx('svg2')} fill={active ? 'rgba(255,255,255,0.08)' : 'rgba(117,102,245,0.08)'} />
        ),
      },
    ],
    [
      ContactType.cooperation,
      {
        content: <Cooperation className={cx('cooperation-content')} key={ContactType.cooperation}></Cooperation>,
        svg: (active?: boolean) => (
          <CooperationSvg className={cx('svg3')} fill={active ? 'rgba(255,255,255,0.08)' : 'rgba(117,102,245,0.08)'} />
        ),
      },
    ],
  ]);
  const handleClick = (key: ContactType) => {
    enhancedNavigate(
      isCommon ? `/${RouterConfigEnum.CommonContactSlug}/${key}` : `/${RouterConfigEnum.ContactUsSlug}/${key}`
    );
  };

  return (
    <>
      <MetaConfig routerPath={RouterConfigEnum.Consult} />
      {!isCommon && <NavHeader isStatic mode="white" />}
      <div className={cx('contact-wrapper', { border: !isCommon })}>
        {/* {isCommon && (
          <div className={cx('back')} onClick={() => window.history.go(-1)}>
            <LeftOutlined /> 返回
          </div>
        )} */}
        {!HIDE_TAB_LIST.includes(fromPage) && (
          <div className={cx('wrapper-nav')}>
            {contactList.map(item => (
              <div
                key={item.type}
                onClick={handleClick.bind(null, item.type)}
                className={cx('list-item', { active: item.type === contactType })}>
                {item.text}
                {renderMap.get(item.type as ContactType)?.svg(item.type === contactType)}
              </div>
            ))}
          </div>
        )}

        {renderMap.get(contactType as ContactType)?.content}
      </div>
      {!isCommon && (
        <>
          <ContactComponent />
          <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} />
          <Back2Top />
        </>
      )}
    </>
  );
};

export default Contact;
